// extracted by extract-css-chunks-webpack-plugin
module.exports = {"note":"reason__note--2jJnU","lighter":"reason__lighter--32HsX","center":"reason__center--3mSMK"};